/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface DeleteNote200Response
 */
export interface DeleteNote200Response {
    /**
     * 
     * @type {string}
     * @memberof DeleteNote200Response
     */
    message?: string;
}


/**
 * Check if a given object implements the DeleteNote200Response interface.
 */
export function instanceOfDeleteNote200Response(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function DeleteNote200ResponseFromJSON(json: any): DeleteNote200Response {
    return DeleteNote200ResponseFromJSONTyped(json, false);
}

export function DeleteNote200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteNote200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function DeleteNote200ResponseToJSON(value?: DeleteNote200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
    };
}

